import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Settings.css';

const Settings = () => {
    const navigate = useNavigate();
    const [adminData, setAdminData] = useState(null);

    useEffect(() => {
        const loadAdminData = () => {
            try {
                const possibleKeys = ['user', 'adminData', 'admin', 'userData', 'authUser'];
                let foundData = null;

                for (let key of possibleKeys) {
                    const stored = localStorage.getItem(key);
                    if (stored) {
                        try {
                            const parsed = JSON.parse(stored);
                            if (parsed && typeof parsed === 'object') {
                                foundData = parsed.user ? parsed.user : parsed;
                                break;
                            }
                        } catch (e) { }
                    }
                }
                setAdminData(foundData);
            } catch (error) {
                console.error('Error loading admin data', error);
            }
        };

        loadAdminData();
    }, []);

    const getInitials = (name) => {
        if (!name) return 'AD';
        return name.substring(0, 2).toUpperCase();
    };

    const getImageUrl = (imagePath) => {
        if (!imagePath) return null;
        if (imagePath.startsWith('http')) return imagePath;
        return `https://hrms.mpdatahub.com/images/${imagePath}`;
    };

    const menuItems = [
        {
            label: 'Terms & Conditions',
            desc: 'Read the terms of using this application',
            path: '/terms-and-conditions',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
            )
        },
        {
            label: 'Privacy Policy',
            desc: 'Learn how we handle your data',
            path: '/privacy-policy',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
            )
        },
        {
            label: 'Account Deletion',
            desc: 'Request permanent removal of your account',
            path: '/account-deletion',
            danger: true,
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                    <path d="M10 11v6"></path>
                    <path d="M14 11v6"></path>
                    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                </svg>
            )
        }
    ];

    return (
        <div className="settings-page">
            <div className="settings-header">
                <h1>Settings</h1>
                <p>Manage your profile and account preferences</p>
            </div>

            {/* Card 1 - Profile Info */}
            <div className="settings-card glass-panel profile-info-card">
                <div className="profile-info-left">
                    <div className="settings-avatar">
                        {adminData?.profile_img ? (
                            <img
                                src={getImageUrl(adminData.profile_img)}
                                alt="Profile"
                                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                            />
                        ) : null}
                        <div className="avatar-fallback" style={{ display: adminData?.profile_img ? 'none' : 'flex' }}>
                            {getInitials(adminData?.name)}
                        </div>
                    </div>
                    <div className="profile-info-text">
                        <h3>{adminData?.name || 'Unknown User'}</h3>
                        <div className="info-row">
                            <span className="info-label">Email</span>
                            <span className="info-value">{adminData?.email || 'N/A'}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">Phone</span>
                            <span className="info-value">{adminData?.mobile || 'N/A'}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Card 2 - Legal & Account Actions */}
            <div className="settings-card glass-panel">
                {menuItems.map((item) => (
                    <div
                        key={item.path}
                        className={`settings-menu-item ${item.danger ? 'danger' : ''}`}
                        onClick={() => navigate(item.path)}
                    >
                        <div className="settings-menu-icon">{item.icon}</div>
                        <div className="settings-menu-text">
                            <span className="menu-label">{item.label}</span>
                            <span className="menu-desc">{item.desc}</span>
                        </div>
                        <div className="settings-menu-arrow">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Settings;